import { render } from "./ProductListPage.vue?vue&type=template&id=06c3852c&scoped=true"
import script from "./ProductListPage.vue?vue&type=script&lang=js"
export * from "./ProductListPage.vue?vue&type=script&lang=js"

import "./ProductListPage.vue?vue&type=style&index=0&id=06c3852c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06c3852c"

export default script